export default __webpack_public_path__ + "static/media/booth_6_sanofipasteur.4af61dc2.png";